import AnimateHeight from 'react-animate-height'
import { useTranslation } from 'react-i18next'
import { ConsentFormTemplate } from '@lmc/common/types'
import { LabelTextBox } from '@lmc/ui-kit'
import { isBrowser, isTablet } from 'react-device-detect'
import { Resident } from '@lmc/ts-common'

type TextEditorProps = {
  isSelected: boolean
  item: ConsentFormTemplate
  resident: Resident
  setCopyOfTemplates?: any
  copyOfTemplates?: any[]
  customEntry?: boolean
  readOnly?: boolean
}

const TextEditor = ({
  isSelected,
  item,
  resident,
  setCopyOfTemplates,
  copyOfTemplates,
  customEntry,
  readOnly = false
}: TextEditorProps) => {
  const { t } = useTranslation()

  const translate = (key: string, variable?: any) =>
    t(`consent.createConsentForms.components.consentModal.${key}`, variable)

  const labelTextBoxTranslate = (key: string, variable?: any) =>
    t(`components.labelTextBox.${key}`, variable)

  const isMobile = !isBrowser && !isTablet

  const content = typeof item?.body === 'string' ? item?.body : ''

  const contentWithNames = content
    .replaceAll('{name}', resident?.preferredName || resident?.name?.first)
    .replaceAll('{resident}', resident?.preferredName || resident?.name?.first)

  return (
    <AnimateHeight
      animateOpacity
      duration={300}
      height={isSelected ? 'auto' : 0}
    >
      <LabelTextBox
        isMobile={isMobile}
        key={item.id}
        localisation={{
          title: item.title,
          subTitle: translate('statement', {
            variable: resident?.preferredName || resident?.name?.first
          }),
          readOnly: labelTextBoxTranslate('readOnly'),
          save: t('general.buttons.save'),
          cancel: t('general.buttons.cancel'),
          clickToAddTitle: translate('clickToAddTitle'),
          loseText: labelTextBoxTranslate('loseText')
        }}
        content={contentWithNames}
        state={readOnly ? 'read-only' : 'display'}
        id={item.id}
        setCopyOfTemplates={setCopyOfTemplates}
        copyOfTemplates={copyOfTemplates}
        customEntry={customEntry}
      />
    </AnimateHeight>
  )
}

export default TextEditor
